const AI_ALERTS_TITLE = 'AI Alerts';
const AI_ALERTS_SENSITIVITY_CONTROL_TITLE = 'AI Alerts Config';

// type EI referes to conetent/ video alerts
// type AI refers to ad

const AI_ALERT_AGW_MGW_DIMENSION_MAPPING = {
  CUSTOMER: { isCustomDimension: false, field: '', key: '', pulse5Label: 'All Traffic' },
  OBJECT: { isCustomDimension: false, field: 'OBJECT_NAME', key: '', pulse5Label: 'Assets' },
  IS_LIVE: {
    isCustomDimension: false,
    field: 'LIVE_VIDEO',
    key: null,
    pulse5Label: 'Content Category',
  },
  CURRENT_CDN: { isCustomDimension: false, field: 'CDN', key: '', pulse5Label: 'CDN' },
  ISP: { isCustomDimension: false, field: 'GEO_ISP', key: '', pulse5Label: 'Isp' },
  CITY: { isCustomDimension: false, field: 'GEO_CITY', key: '', pulse5Label: 'City' },
  PLAYER_NAME: {
    isCustomDimension: false,
    field: 'TAG',
    key: 'c3.player.name',
    pulse5Label: 'Player Name',
  },
  OS_FAMILY: {
    isCustomDimension: false,
    field: 'm3.dv.osf',
    key: null,
    pulse5Label: 'Device Operating System Family',
  },
  STREAMING_PROTOCOL: {
    isCustomDimension: true,
    field: 'TAG',
    key: 'protocol',
    pulse5Label: 'Streaming Protocol',
  },
  CHANNEL: { isCustomDimension: true, field: 'TAG', key: 'channel', pulse5Label: 'Channel' },
  AD_CREATIVE_ID: {
    isCustomDimension: false,
    field: 'TAG',
    key: 'c3.ad.creativeId',
    pulse5Label: 'Ad Creative Id',
  },
  AD_ID: { isCustomDimension: false, field: 'TAG', key: 'c3.ad.id', pulse5Label: 'Ad Id' },
  AD_TECHNOLOGY: {
    isCustomDimension: false,
    field: 'TAG',
    key: 'c3.ad.technology',
    pulse5Label: 'Ad Technology',
  },
  // app dimensions
  // https://conviva.atlassian.net/wiki/spaces/dev/pages/1795588170/AI+Alerts+for+App+Analytics+-+Architecture
  ['App Name']: { isCustomDimension: false, field: 'app_id', key: '', pulse5Label: 'App Name' },
  ['Device Operating System Family']: {
    isCustomDimension: false,
    field: 'device_operating_system_family',
    key: '',
    pulse5Label: 'Device Operating System Family',
  },
  ['Page Path']: {
    isCustomDimension: false,
    field: 'page_urlpath',
    key: '',
    pulse5Label: 'Page Path',
  },
  ['Page Host']: {
    isCustomDimension: false,
    field: 'page_urlhost',
    key: '',
    pulse5Label: 'Page Host',
  },
};

const AiAlertGraphSeriesKeys = [
  'ai-alert-timeseries',
  'ai-alert-threshold',
  'ai-alert-baseline',
  'ai-alert-tMinus7',
  'ai-alert-pcp',
];

const SeverityColors = {
  Critical: '#D0021B',
  Warning: '#FF9300',
  Info: '#788BA9',
  Ended: '#4A4A4A',
};

// TODO: not sure how this is used, rgb-'a' is not specified so opactiy will be ignored
const SeverityColorsWithOpacity = {
  Critical: 'rgb(208, 2, 27, 0.1)',
  Warning: 'rgb(255, 184, 0, 0.1)',
  Info: 'rgb(155, 164, 181, 0.1)',
  Ended: 'rgb(74, 74, 74, 0.1)',
};

const SeverityText = {
  Critical: 'Critical',
  Warning: 'Warning',
  Info: 'Info',
  Ended: 'Ended',
};

const GraphColors = {
  baseline: '#BD10E0',
  threshold: '#0046FF',
  exceptAnamoly: '#6a8e3b',
  issueStarted: '#4A4A4A',
  pcpDrop: '#F3D4D4',
  pcpDropBorder: '#C32828',
};

const AI_ALERT_DATE_SHORTCUTS = {
  today: 'Today',
  past7Days: '7 days',
  past15Days: '15 days',
  past30Days: '30 days',
};

const GraphMetricMapping = {
  VideoPlaybackFailures: 'VideoPlaybackFailuresPercentage',
  VideoStartFailures: 'VideoStartFailuresPercentage',
  ExitBeforeVideoStarts: 'ExitBeforeVideoStartsPercentage',
  VideoPlaybackFailuresTech: 'VideoPlaybackFailuresTechPercentage',
  VideoStartFailuresTech: 'VideoStartFailuresTechPercentage',
};

const AI_ALERT_SUMMARY_TABS = [
  {
    key: 'all_metrics',
    title: 'All Metrics',
    columns: [],
    type: 'all',
  },
  {
    key: 'content_metrics',
    title: 'Video Metrics',
    columns: [],
    type: 'EI',
  },
  {
    key: 'ad_metrics',
    title: 'Ad Metrics',
    columns: [],
    type: 'AI',
  },
  {
    key: 'app_metrics',
    title: 'ECO Metrics',
    columns: [],
    type: 'APP',
  },
];

const AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS = [
  {
    value: 'EI',
    label: 'Video',
  },
  {
    value: 'AI',
    label: 'Ad',
  },
  {
    value: 'APP',
    label: 'ECO',
  },
];

const AI_ALERT_ACTIVE_TAG = [
  {
    key: 'Active',
    title: 'Active',
    color: '#0F93F5',
    type: 'all',
  },
];

const AI_ALERT_SEVERITY_TAGS = [
  {
    key: 'Total',
    title: 'All Alerts',
    color: '#000',
    type: 'all',
  },
  {
    key: 'Critical',
    title: 'Critical',
    color: SeverityColors.Critical,
    type: ['EI', 'APP'],
  },
  {
    key: 'Warning',
    title: 'Warning',
    color: SeverityColors.Warning,
    type: ['EI', 'APP'],
  },
  {
    key: 'Info',
    title: 'Info',
    color: SeverityColors.Info,
    type: ['EI', 'APP'],
  },
];

const DEFAULT_SENSITIVITY_CONFIG_FOR_METRIC = {
  deviation: '1.00',
  app: 'ei',
  asf: 1,
  sustain: 3,
  warningSustain: null,
  criticalSustain: null,
  impactedUnique: 5,
  impactedUniquePct: 0,
  warningImpactedUnique: null,
  warningImpactedUniquePct: null,
  criticalImpactedUnique: null,
  criticalImpactedUniquePct: null,
  sustainPcpDrop: 10,
  warningPcpDrop: null,
  criticalPcpDrop: null,
};

const DEFAULT_SENSITIVITY_CONFIG_FOR_APP_METRIC = {
  deviation: '1.00',
  app: 'ae',
  asf: 1,
  sustain: 3,
  warningSustain: null,
  criticalSustain: null,
  impactedUnique: 5,
  impactedUniquePct: 0,
  warningImpactedUnique: null,
  warningImpactedUniquePct: null,
  criticalImpactedUnique: null,
  criticalImpactedUniquePct: null,
  sustainPcpDrop: 10,
  warningPcpDrop: null,
  criticalPcpDrop: null,
};

const DEFAULT_SENSITIVITY_CONFIG_FOR_AD_METRIC = {
  deviation: '1.00',
  app: 'ai',
  asf: 8,
  sustain: 1,
  warningSustain: null,
  criticalSustain: null,
  impactedUnique: 10,
  impactedUniquePct: null,
  warningImpactedUnique: null,
  warningImpactedUniquePct: null,
  criticalImpactedUnique: null,
  criticalImpactedUniquePct: null,
};

// disabled two of the device series based on product input
const deviceLabels = {
  //impactedUniques: 'Impacted Unique Devices',
  //totalUniques: 'Total Unique Devices',
  cumulativeImpactedUniques: 'Cumulative Impacted Unique Devices',
  totalCumulativeImpactedUniques: 'Total Cumulative Unique Devices',
};
const deviceSeriesKeys = Object.keys(deviceLabels);

const AI_ALERT_DIAGNOSTIC_CHART_LABEL_MAP = {
  APP: {
    PCP_OR_PCT: 'PCT Drop',
  },
  EI: {
    PCP_OR_PCT: 'PCP Drop',
  },
  AI: {
    PCP_OR_PCT: 'PCP Drop',
  },
};

export {
  AI_ALERTS_TITLE,
  AI_ALERT_DATE_SHORTCUTS,
  AI_ALERTS_SENSITIVITY_CONTROL_TITLE,
  AI_ALERT_SUMMARY_TABS,
  AI_ALERT_SEVERITY_TAGS,
  AI_ALERT_ACTIVE_TAG,
  AI_ALERT_AGW_MGW_DIMENSION_MAPPING,
  DEFAULT_SENSITIVITY_CONFIG_FOR_METRIC,
  DEFAULT_SENSITIVITY_CONFIG_FOR_AD_METRIC,
  DEFAULT_SENSITIVITY_CONFIG_FOR_APP_METRIC,
  SeverityColors,
  SeverityColorsWithOpacity,
  GraphColors,
  GraphMetricMapping,
  SeverityText,
  AiAlertGraphSeriesKeys,
  deviceLabels,
  deviceSeriesKeys,
  AI_ALERT_DIAGNOSTIC_CHART_LABEL_MAP,
  AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS,
};
